import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'

const app = (
   <Router>
      <Switch>
         <Route exact component={App} path="/" />
         <Route path="*" component={<div>Not found ...</div>} />
      </Switch>
   </Router>
)

ReactDOM.render(app, document.getElementById('root'))
